@if (isLoaded && tenants.length) {
  <div class="modules-wrapper">
    <div>
      <div class="d-flex justify-content-center modules">
        @for (tenant of tenants; track trackByTenantId($index, tenant)) {
          @if (tenant.courseFormData) {
            <div>
              <form ngNoForm
                method="POST"
                action="https://secure.princetonreview.com/ltisso/launch"
                enctype="application/x-www-form-urlencoded">
                <input type="hidden" name="context_id" [value]="tenant.courseFormData.contextId" />
                <input type="hidden" name="user_id" [value]="tenant.courseFormData.userId" />
                <input type="hidden" name="lis_person_name_given" [value]="tenant.courseFormData.lisPersonNameGiven" />
                <input type="hidden" name="lis_person_name_family" [value]="tenant.courseFormData.lisPersonNameFamily" />
                <input type="hidden" name="custom_zee" [value]="tenant.courseFormData.customZee" />
                <input type="hidden" name="custom_userid" [value]="tenant.courseFormData.customUserId" />
                <input type="hidden" name="custom_statusid" [value]="tenant.courseFormData.customStatusId" />
                <input type="hidden" name="custom_address1country" [value]="tenant.courseFormData.customAddress1Country" />
                <input type="hidden" name="custom_clienttype" [value]="tenant.courseFormData.customClientType" />
                <input type="hidden" name="custom_studenttype" [value]="tenant.courseFormData.customStudentType" />
                <input type="hidden" name="custom_cancontact" [value]="tenant.courseFormData.customCanContact" />
                <input type="hidden" name="custom_cancontactschools" [value]="tenant.courseFormData.customCanContactSchools" />
                <input type="hidden" name="custom_cancontactsurveys" [value]="tenant.courseFormData.customCanContactSurveys" />
                <input type="hidden" name="custom_cancontactnewsletters" [value]="tenant.courseFormData.customCanContactNewsLetters" />
                <input type="hidden" name="oauth_consumer_key" [value]="tenant.courseFormData.oAuthConsumerKey" />
                <input type="hidden" name="oauth_nonce" [value]="tenant.courseFormData.oAuthNonce" />
                <input type="hidden" name="oauth_signature" [value]="tenant.courseFormData.oAuthSignature" />
                <input type="hidden" name="oauth_signature_method" [value]="tenant.courseFormData.oAuthSignatureMethod" />
                <input type="hidden" name="oauth_timestamp" [value]="tenant.courseFormData.oAuthTimestamp" />
                <input type="hidden" name="oauth_version" [value]="tenant.courseFormData.oAuthVersion" />
                <button type="submit" class="pointable" style="background-color:unset;border:none;">
                  <img [src]="tenant.iconImageUri" class="w-100" />
                </button>
              </form>
            </div>
          }
        }
      </div>
    </div>
  </div>
}

@if (isLoaded && !tenants.length) {
  <div class="fs-1 mt-5 text-center">
    * An active subscription is required to access this content *
  </div>
}
